import { MainLayout } from "@src/component/home/renewal/main/pc/MainLayout";
import { MainContentsMobile } from "./MainContentsMobile";
import { MainFooterMobile } from "./MainFooterMobile";
import { MainGnbMobile } from "./MainGnbMobile";

const MainPageMobile = () => (
	<MainLayout>
		<MainGnbMobile type="client" />
		<MainContentsMobile />
		<MainFooterMobile />
	</MainLayout>
);

export default MainPageMobile;
